import { Directive, ElementRef, Renderer2, effect, inject, input } from '@angular/core';

@Directive({
    selector: '[msSliderGradient]',
})
export class SliderGradientDirective {
    private readonly el = inject(ElementRef);
    private readonly renderer = inject(Renderer2);
    readonly msSliderGradient = input<number[]>([]);
    readonly sliderValue = input<number>(0);
    readonly centerValue = input<number | undefined>();
    constructor() {
        effect(() => {
            const steps = this.msSliderGradient();
            const sliderValue = this.sliderValue();
            const center = this.centerValue();

            if (steps.length < 2) {
                this.renderer.removeStyle(this.el.nativeElement, 'background');

                return;
            }

            const currentIndex = steps.indexOf(sliderValue);
            let centerIndex = Math.floor(steps.length / 2);
            if (center !== undefined && steps.includes(center)) {
                centerIndex = steps.indexOf(center);
            }
            const currentPos = (currentIndex / (steps.length - 1)) * 100;
            const centerPos = (centerIndex / (steps.length - 1)) * 100;

            const from = Math.min(currentPos, centerPos);
            const to = Math.max(currentPos, centerPos);

            const gradient = `linear-gradient(to right,
        var(--theme-body-20) 0%,
        var(--theme-body-20) ${from}%,
        var(--theme-info) ${from}%,
        var(--theme-info) ${to}%,
        var(--theme-body-20) ${to}%,
        var(--theme-body-20) 100%)`;

            this.renderer.setStyle(this.el.nativeElement, 'background', gradient);
        });
    }
}
